<template>
  <div class="teaching-score-confirm-title">
    <div class="label">{{label}}</div>
    <div class="scale">({{scale}}%)</div>
  </div>
</template>

<script>
export default {
  name: 'TeachingScoreConfirmTitle',
  props: {
    label: {
      type: String,
      required: true
    },
    scale: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-confirm-title {
    display: inline-block;
    vertical-align: middle;
    & > .scale {
      font-weight: normal;
      line-height: 100%;
      transform: scale(.9);
    }
  }
</style>
